import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

/** Warning icon for a negative billing difference: subcontractors have more approved than was billed to the investor. */
const BillingDifferenceMark: React.FC = () => {
  const { t } = useTranslation()
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} role="img" aria-label={t('CostControl_billing_difference_warning')} className="inline-flex"><AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" /></span>
        </TooltipTrigger>
        <TooltipContent>{t('CostControl_billing_difference_warning')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
export default BillingDifferenceMark
